import type { RoofFace } from "building-types/roofs/roofFace";
import type { RoofFaceType } from "building-types/roofs/roofFace";
import type { RoofElevationPlanSettings, RoofPlanSettings } from "building-types/settings/roofPlanSettings";
import type { RoofSide } from "building-types/settings/roofTypes";
import type { Face } from "geom/brep";

export function facesToRoofFaces(
  faces: Face[],
  type: RoofFaceType,
  side: RoofSide,
  isDormer: boolean = false,
  annotationSettings: RoofPlanSettings & RoofElevationPlanSettings = {},
  disableOverhangClipping: boolean = false,
): RoofFace[] {
  return faces
    .filter((x) => !!x)
    .map((x): RoofFace => {
      return roofFaceNew(type, side, x, isDormer, annotationSettings, disableOverhangClipping);
    });
}

export function roofFaceNew(
  type: RoofFaceType,
  side: RoofSide,
  face: Face,
  isDormer: boolean = false,
  annotationSettings: RoofPlanSettings & RoofElevationPlanSettings = {},
  disableOverhangClipping: boolean = false,
): RoofFace {
  return {
    type,
    side,
    face,
    isDormer,
    annotationSettings,
    disableOverhangClipping,
  };
}
